module.exports = __webpack_public_path__ + "static/Razor1-98cf8af3b9aaa2438f18f77776dd2f8c.jpg";